const appsBar = {
  state: {
    clipped: true,
    clients: [],
    select_client: { name: 'Jason Oner', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg', gender: 'M', newMessageNum: 1, online: true, age: 22, address: 'Hong Kong', bod: '12/12/2019' },
    floating: false,
    items: [
      { title: 'Import Record', icon: 'far fa-list-alt', child: [], to: '/import_record' },
      { title: 'View All Record', icon: 'fas fa-user-alt', child: [], to: '/view_record' },
      { title: 'View Import Record', icon: '', child: [], to: '/viewImportRecord' },
      { title: 'View User', icon: '', child: [], to: '/viewUsers' },
      { title: 'View Report', icon: '', child: [], to: '/viewReports' }
    ],
    message: {
      unReadMessage: 1
    },
    loading_status: false,
    mini: false,
    right: null,
    route: '',
    searchValue: '',
    status: null,
    title: 'Dashboard'
  },
  mutations: {
    setLoadingState (state:any, payload:Boolean) {
      state.loading_status = payload
    }
  }
}

export default appsBar
